import React, {Fragment, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import DialogMUI from '../../../shared/DialogMUI';
import {closeModal} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import ButtonMUI from '../../../shared/ButtonMUI';
import RatingEdit from '../RatingEdit';
import AvatarUsers from '../../../assets/images/avatars/avatar-users.png';
import './ReviewPopup.scss';
import * as yup from 'yup';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {postEmployeeReview} from '../../../redux/actions/employee/employeeActions';
import {useTranslation} from 'react-i18next';
import {notifySuccess} from '../../../helpers/notifySnack';
import Tooltip from '@material-ui/core/Tooltip';

const ReviewPopup = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [submit, setSubmit] = useState(false);
  const popupToShow = useSelector(({app}) => app.popupToShow);
  const popupVisible = popupToShow === POPUPS.REVIEW_POPUP;
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const {employeeForReview} = useSelector((state) => state.employee);

  const [ratings, setRatings] = useState([]);

  useEffect(() => {
    if (employeeForReview && employeeForReview.length > 0) {
      const initialRatings = employeeForReview?.flatMap(({employees, id}) =>
        employees?.map(({employeeId}) => ({
          employeeId,
          projectId: id,
          mark: 0
        }))
      );
      setRatings(initialRatings);
    }
  }, [employeeForReview]);

  const onCloseHandler = () => {
    dispatch(closeModal());
    setTimeout(() => {
      setSubmit(false);
    }, 150);
  };

  const schema = yup.object().shape({});

  const {
    handleSubmit,
    formState: {isSubmitting}
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema)
  });

  const handleRatingChange = (employeeId, projectId, newRating) => {
    setRatings((prevRatings) =>
      prevRatings.map((rating) =>
        rating.employeeId === employeeId && rating.projectId === projectId ? {...rating, mark: newRating} : rating
      )
    );
  };

  const onSubmit = async () => {
    setSubmit(true);
    try {
      const res = await dispatch(postEmployeeReview({reviews: ratings}));
      if (res.payload && res.payload.status === 200) {
        notifySuccess(t('all.successfully'));
      }
    } catch (err) {
      setSubmit(false);
      console.log(err);
    } finally {
      onCloseHandler();
    }
  };

  const allRatingsProvided = ratings?.length && ratings.every(({mark}) => mark > 0);

  const showTooltip = !allRatingsProvided;

  return (
    <DialogMUI open={popupVisible} isClosable={false} title={t('ReviewPopup.title')}>
      <form className='review__modal' onSubmit={handleSubmit(onSubmit)}>
        <div className='review__descriptions'>{t('ReviewPopup.description')}</div>
        <div className='review__wrapper'>
          <div className='review__list'>
            {employeeForReview.map(({id, employees, address}) => (
              <Fragment key={id}>
                {employees?.length > 0 && (
                  <div className='review__item'>
                    <div className='review__project'>{address}</div>
                    <div className='review-employees-list'>
                      {employees?.map((employee) => {
                        const {employeeId, firstName, avatar, positionName, position, status} = employee;
                        return (
                          <div className='review-employees' key={employeeId}>
                            <div className='review-employees__info'>
                              <div className='review-employees__info-avatar'>
                                <img
                                  className='avatar-image'
                                  src={avatar || AvatarUsers}
                                  alt={firstName || 'No Name'}
                                />
                                <div className={`status ${status === 'active' ? 'active' : ''}`} />
                              </div>
                              <div className='review-employees__info-user'>
                                <div className='review-employees__info-name'>{firstName || 'Unnamed'}</div>
                                <div className='review-employees__info-role'>
                                  {positionName || position || 'No Position'}
                                </div>
                              </div>
                            </div>
                            <RatingEdit
                              mark={0}
                              onRatingChange={(rating) => handleRatingChange(employeeId, id, rating)}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Fragment>
            ))}
          </div>
        </div>
        <Tooltip
          open={isHovered && showTooltip}
          placement='bottom'
          arrow
          title='Оцініть всіх учасників команди, щоб надіслати оцінку.'
        >
          <div
            className='review-employees__btns'
            onMouseEnter={() => setIsHovered(true)} // Наведение
            onMouseLeave={() => setIsHovered(false)} // Уход мыши
          >
            <ButtonMUI formAction disabled={submit || isSubmitting || !allRatingsProvided}>
              {t('ReviewPopup.button')}
            </ButtonMUI>
          </div>
        </Tooltip>
      </form>
    </DialogMUI>
  );
};

export default ReviewPopup;
